import React from 'react';

const LinkHorizontalIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" fill="none">
      <path
        d="M9 17H6A5 5 0 116 7h3m6 0h3a5 5 0 110 10h-3V7zM8 12h8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkHorizontalIcon;
